import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodmenuService } from 'src/app/services/addfoodmenu.service';
import { FoodcourtmenuService } from 'src/app/services/foodcourtmenu.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-update-food-menu',
  templateUrl: './update-food-menu.component.html',
  styleUrls: ['./update-food-menu.component.scss']
})
export class UpdateFoodMenuComponent implements OnInit {

  @ViewChild('uploadImages', { static: false }) uploadImages: ElementRef;

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  prakList: any = [];
  finalSubmissionArray = [];
  afterConvertFile: any = [];
  images = [];
  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];
  currentProcessingImg: any = 0;
  imgId: any = 0;
  finalImageList: any = [];
  photoData: any = {};
  uploadData: any;
  selectedPark = localStorage.getItem('parkId');
  parkDetails;
  displayPark = '';
  imageName: any;
  menuType = [];
  menuAvability = [];
  menuCuissine = [];
  vendorId: any;
  menuId: any;
  menuDetails: any;
  checkedOnlyUsersList: any;
  removeOldImage = 0;
  foodImageName: any;

  myForm!: FormGroup;
  imageTobeUpload: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodmenuService: AddfoodmenuService,
    private foodcourtmenuService: FoodcourtmenuService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    this.myForm = this.formBuilder.group({
      newMenuGroups: this.formBuilder.array([this.newNotes()]),
      ModifiedBy: '',
      isActive: true,
    });

    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    this.removeOldImage = 0;
    this.route.params.subscribe((params) => {
      this.menuId = params['id'];
    });

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');
    this.selectedPark = localStorage.getItem('parkId');

    this.foodcourt.FoodType = '';
    this.foodcourt.FoodCuisine = '';
    this.foodcourt.IsAvailable = '';

    this.menuType.push(
      {
        id: "Veg",
        name: "Veg"
      },
      {
        id: "Non-Veg",
        name: "Non-Veg"
      }
    );

    this.menuAvability.push(
      {
        id: "true",
        name: "Available"
      },
      {
        id: "false",
        name: "Not Available"
      }
    );

    this.menuCuissine.push(
      {
        id: "Indian",
        name: "Indian"
      },
      {
        id: "North Indian",
        name: "North Indian"
      },
      {
        id: "Continental",
        name: "Continental"
      },
      {
        id: "Italian",
        name: "Italian"
      },
      {
        id: "Chinese",
        name: "Chinese"
      },
      {
        id: "Japanese",
        name: "Japanese"
      },
      {
        id: "Thai",
        name: "Thai"
      },
      {
        id: "Korean",
        name: "Korean"
      },
      {
        id: "American",
        name: "American"
      },
      {
        id: "Mexican",
        name: "Mexican"
      },
      {
        id: "International",
        name: "International"
      }
    );

    this.getMenuDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.foodcourtmenuService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  onFileChange(event: any, file: any) {

    this.images = [];

    if (event.target.files && event.target.files[0]) {
      const fileItem = event.target.files[0];
      console.log(fileItem);

      var filesAmount = event.target.files.length;

      // for (let i = 0; i < filesAmount; i++) {
      //   var reader = new FileReader();
      //   reader.readAsDataURL(event.target.files[i]);

      //   reader.onload = (innerEvent: any) => {
      //     // this.imgId = this.imgId + 1;
      //     this.images.push({
      //       // imgId: this.imgId,
      //       imgBase64: innerEvent.target.result,
      //       imgFile: event.target.files[i],
      //     });

      //     this.myForm.patchValue({
      //       couponimage: this.images,
      //     });
      //   };
      // }


      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (innerEvent: any) => {
        // this.imgId = this.imgId + 1;
        this.images.push({
          imgBase64: innerEvent.target.result,
          imgFile: event.target.files[0],
        });
        // this.myForm.patchValue({
        //   couponimage: this.images,
        // });
      };

      this.imageName = event.target.files[0].name;
      console.log(event.target.files[0].name);
      console.log(this.images);
    }
  }

  goToListPage() {
    this.vendorId = localStorage.getItem('vendor_id');
    this.router.navigate(['/list-food-menu/' + this.vendorId]);
  }

  dataURLtoFile(dataurl: string, filename: any) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename.split('?').at(0), { type: mime });
  }

  newMenuGroups(): FormArray {
    return this.myForm.get('newMenuGroups') as FormArray;
  }

  newNotes(): FormGroup {
    return this.formBuilder.group({
      FoodName: ['', [Validators.required, Validators.maxLength(100)]],
      FoodType: ['', [Validators.required]],
      FoodCuisine: ['', [Validators.required]],
      FoodPrice: ['', [Validators.required]],
      FoodDescription: ['', [Validators.required]],
      IsAvailable: ['', [Validators.required]],
      ParkId: [''],
      file: [''],
      VendorPhotos: [''],
      ModifiedBy: '',
      isActive: true,
    });
  }

  addMore(): void {
    this.newMenuGroups().push(this.newNotes());
  }

  removeBlock(i: number) {
    this.newMenuGroups().removeAt(i);
  }

  onSubmit(): void {

    this.removeOldImage = 0;

    if (this.myForm.valid) {

      const uploadData = new FormData();

      // for (let i = 0; i <= this.images.length - 1; i++) {
      //   this.afterConvertFile.push(
      //     this.dataURLtoFile(
      //       this.images[i].imgBase64,
      //       this.images[i].imgFile.name
      //     )
      //   );
      // }

      if (this.images.length > 0) {
        this.afterConvertFile.push(
          this.dataURLtoFile(
            this.images[0].imgBase64,
            this.images[0].imgFile.name
          )
        );
      }
      let imgFileProperties = this.afterConvertFile.map(
        (img: any, filename: any) => {
          let properties = {
            photoData: img,
            photoName: img.name,
          };
          return properties;
        }
      );


      // for (let i = 0; i <= imgFileProperties.length - 1; i++) {
      //   uploadData.append(
      //     'CouponImage[' + i + '].photoData',
      //     imgFileProperties[i].photoData
      //   );
      //   uploadData.append(
      //     'CouponImage[' + i + '].photoName',
      //     imgFileProperties[i].photoName.split('?').at(0)
      //   );
      // }


      // uploadData.append('CouponImage', imgFileProperties[0].photoName);


      // this.myForm.patchValue({
      //   CouponImage: imgFileProperties,
      // });

      //for (let i = 0; i <= this.myForm.value.newMenuGroups.length - 1; i++) {

      if (imgFileProperties.length > 0) {
        this.imageTobeUpload = imgFileProperties[0].photoData;
      } else {
        this.imageTobeUpload = '';
      }

      uploadData.append('FoodCourtVendorId', this.vendorId);
      uploadData.append('FoodCourtVendorMenuId', this.menuId);
      uploadData.append('FoodName', this.myForm.value.newMenuGroups[0].FoodName);
      uploadData.append('FoodType', this.myForm.value.newMenuGroups[0].FoodType);
      uploadData.append('FoodCuisine', this.myForm.value.newMenuGroups[0].FoodCuisine);
      uploadData.append('FoodPrice', this.myForm.value.newMenuGroups[0].FoodPrice);
      uploadData.append('FoodDescription', this.myForm.value.newMenuGroups[0].FoodDescription);
      uploadData.append('IsAvailable', this.myForm.value.newMenuGroups[0].IsAvailable);
      if (this.removeOldImage == 1) {
        uploadData.append('photoData', '');
        uploadData.append('FoodImageName', '');
      } else {
        uploadData.append('photoData', this.imageTobeUpload);
        uploadData.append('FoodImageName', this.imageName ? this.imageName : this.foodImageName);
      }
      uploadData.append('ModifiedBy', localStorage.getItem('claAdminId'));
      uploadData.append('IsActive', 'true');

      //}

      this.finalSubmissionArray = [];
      this.addfoodmenuService
        .updateFoodCourtMenu(uploadData)
        .subscribe((res) => {
          this.router.navigate(['/list-food-menu/' + this.vendorId]);
        });
    } else {
      this.myForm.markAllAsTouched();
    }
  }

  removeImage(i: any) {
    console.log(i);
    this.images.splice(i, 1);
    this.imageName = '';
  }

  getMenuDetails() {
    this.foodcourtmenuService.foodMenuDetails(this.menuId).subscribe((res) => {
      if (res?.isValid === true) {
        this.menuDetails = res;

        this.vendorId = this.menuDetails?.data.foodCourtVendorId;
        this.foodcourt.FoodName = this.menuDetails?.data.foodName;
        this.foodcourt.FoodType = this.menuDetails?.data.foodType;
        this.foodcourt.FoodCuisine = this.menuDetails?.data.foodCuisine;
        this.foodcourt.FoodPrice = this.menuDetails?.data.foodPrice;
        this.foodcourt.IsAvailable = this.menuDetails?.data.isAvailable;
        this.foodcourt.FoodDescription = this.menuDetails?.data.foodDescription;
        this.foodImageName = this.menuDetails?.data.foodImageName;

        // Patch form values to avoid ExpressionChangedAfterItHasBeenCheckedError
        if (this.myForm && this.myForm.get('newMenuGroups')) {
          const menuGroup = (this.myForm.get('newMenuGroups') as FormArray).at(0);
          if (menuGroup) {
            menuGroup.patchValue({
              FoodName: this.menuDetails?.data.foodName || '',
              FoodType: this.menuDetails?.data.foodType || '',
              FoodCuisine: this.menuDetails?.data.foodCuisine || '',
              FoodPrice: this.menuDetails?.data.foodPrice || '',
              FoodDescription: this.menuDetails?.data.foodDescription || '',
              IsAvailable: this.menuDetails?.data.isAvailable || '',
            }, { emitEvent: false });
          }
        }

        if (this.menuDetails.data?.foodImagePath != null || this.menuDetails.data?.foodImagePath != 'null') {
          fetch(this.menuDetails.data?.foodImagePath)
            .then((response) => response.blob())
            .then((blob) => {
              var reader = new FileReader();
              // const url = URL.createObjectURL(blob);
              reader.readAsDataURL(blob);
              reader.onload = (innerEvent: any) => {
                this.afterConvertFile.push(
                  this.dataURLtoFile(
                    innerEvent.target.result,
                    this.menuDetails.data?.foodImagePath.split('?').at(0).split('/').at(4)
                  )
                );
              };
            });
        }

        this.checkedOnlyUsersList = [];
        this.checkedOnlyUsersList.push(this.menuDetails.data);
        console.log(this.checkedOnlyUsersList);

        // Use setTimeout to push form updates to next change detection cycle
        setTimeout(() => {
          this.cdr.detectChanges();
        }, 0);
      }
    });
  }

  removeImageOld(i: any) {
    this.removeOldImage = 1;
    this.afterConvertFile.length = 0;
    this.menuDetails.data?.foodImagePath.splice(i, 1);

    fetch(this.menuDetails.data?.foodImagePath)
      .then((response) => response.blob())
      .then((blob) => {
        var reader = new FileReader();
        // const url = URL.createObjectURL(blob);
        reader.readAsDataURL(blob);
        reader.onload = (innerEvent: any) => {
          this.afterConvertFile.push(
            this.dataURLtoFile(
              innerEvent.target.result,
              this.menuDetails.data?.foodImagePath.split('?').at(0).split('/').at(4),
            )
          );
        };
      });

    console.log(this.afterConvertFile);

    if (this.menuDetails.data?.foodCourtVendorPhotos.length - 1 == -1) {
      this.afterConvertFile.length = 0;
    }
  }

}
